import { HttpClient } from '@angular/common/http';
// import { Environment } from '@angular/compiler-cli/src/ngtsc/typecheck/src/environment';
import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormGroupName,
  Validators,
} from '@angular/forms';
import { ControlTypeServiceService } from 'src/app/control-type-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from '@azure/msal-angular';
import * as msalBrowser from '@azure/msal-browser';
import { Subject, filter, takeUntil } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { RolesService } from 'src/app/auth/roles.service';
import { uaepassService } from 'src/app/auth/auth.uaepass.service';
import { UAEPassResponse } from 'src/app/views/interface/apiResponseInterface';
import { Environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { DOCUMENT } from '@angular/common';
import { getCreateFacilityMemberProfile } from '../../interface/createFacilityMemberProfile';
import { AuthSignalRService } from '../../../signalr/auth.signalr.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {

  emiratesIdPopUp: boolean = false;
  errorLogin: boolean = false;
  errorMessage: any;
  errorMessageArabic: any;
  MSALError: any;
  nonDohLoginForm!: FormGroup;
  dohLogPopUp: boolean = false;
  dohLoginForm!: FormGroup;
  rolesForm!: FormGroup;
  roles : any=["Manager","Admin"];
  facilityMemberProfile!: getCreateFacilityMemberProfile;
  emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@(doh\.gov\.ae|adphc\.gov\.ae)$/i;
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  userRole!: string;
  UAEEID: any;
  UAEPassToken: any;
  private integrationURL = Environment.integrationURL;
  private provisonedUrl = Environment.provisonedUrl;
  private uaePassConfig = Environment.uaePassConfig;
  cddIdnDiseaseList!: any[];
  cddNationalityList!: any[];
  authenticateErrorModal: boolean = false;
  authenticateErrorModalHCF: boolean = false;
  showRoles: any = false;
  FacilityMemberProfileID: any;
  recallLogin: boolean = false;
  showPhpLoader: boolean = true;
  emirateId: any;
  uaePassToken: any;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private route: Router,
    private activeRoute: ActivatedRoute,
    private http: HttpClient,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authMsalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private role: RolesService,
    private apiServices: ControlTypeServiceService,
    private UAEPassService: uaepassService,
    private spinner: NgxSpinnerService,
    @Inject(DOCUMENT) private document: Document,
    private signalR: AuthSignalRService
  ) {
    this.nonDohLoginForm = this.fb.group({
      emiratesId: ['', Validators.required],
    });
    this.dohLoginForm = this.fb.group({
      dohEmail: [
        '',
        [Validators.required, Validators.pattern(this.emailPattern)],
      ],
    });
    this.rolesForm = this.fb.group({
      roleControl: ['', Validators.required],
    });
  }

  ngOnInit() {
    localStorage.clear();
    sessionStorage.clear();
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    if (token && role) {
      if (this.role.amrSuperRole() || this.role.amrBasicRole()) {
        this.route.navigate(['/dashboard/amr-dashboard']);
      } else if (this.userRole?.includes('IDN - CDD Basic User') || this.userRole?.includes('IDN - CDD User') || this.userRole?.includes('IDN - CDD Super User')) {
        this.route.navigate(['/dashboard']);
      } else if (this.userRole?.includes('AMR - Healthcare Facility Users')) {
        this.route.navigate(['/dashboard/amr-files']);
      } else if (this.userRole?.includes('IDN - Healthcare Facility User')) {
        this.route.navigate(['/dashboard/idn-notifications']);
      }
    }

    this.activeRoute.queryParams.subscribe(async (params: any) => {
      let accessCode = params['code'];
      let phpToken = params['accessToken'];
      let phpType = params['accessType'];
      let phpEmail = params['email'];
      let phpEmiratesId = params['eid'];
      if (accessCode) {
        this.getUserInfoFromIntegration(accessCode);
      } else if (phpToken && phpType) {
        if (phpType?.toLowerCase()?.trim() == "external") {
          localStorage.setItem('provisioned', "1")
        }

        let payload:any = {}
        payload.application_password = phpToken
        payload.application_user = phpEmail || phpEmiratesId
        payload.isDOH = phpEmail ? true : false
        this.showPhpLoader = true
        this.onPHPLogin(payload)
      }
      let error = params['error']
      if (error) {
        if (error == 'invalid_request' || error == 'login_required' || error == 'access_denied' || error == 'cancelledOnApp') {
          this.errorMessage = `User cancelled the login.`
          this.errorMessageArabic = `قام المستخدم بإلغاء تسجيل الدخول`;
        }
        this.emiratesIdPopUp = true;
      }
    });

    this.authMsalService.instance.enableAccountStorageEvents();
    let loginSUccess = msalBrowser.EventType.LOGIN_SUCCESS;
    this.msalBroadcastService.msalSubject$
      .pipe(filter((msg: msalBrowser.EventMessage) => msg.eventType === loginSUccess))
      .subscribe((result: msalBrowser.EventMessage) => {
        if (result) {
          const token = result?.payload
          this.setLoginDisplay(token);
        }
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  /* ends here */
  loginModal() {
    this.dohLogPopUp = true;
  }

  loginUAEPass() {
    return this.UAEPassService.redirectToAuthenticate();
  }
  checkRole(emirateId:string,uaePassToken:string, facilityMemberProfileID:string) {
     
    this.emirateId = emirateId;
    this.uaePassToken = uaePassToken;
    this.getOptionsFacilityMemberProfile();
        this.showRoles = true;
    
  }
  getOptionsFacilityMemberProfile() {
     
    this.apiServices
      .GetFacilityMemberProfileOptionset()
      .subscribe((response: any) => {
         
        if (response.statusCode == 200) {
          const data = response.result;
          this.facilityMemberProfile = data?.reduce((result: any, item: any) => {
          const key = Object.keys(item)[0];
          result[key] = item[key];
          return result;
          }) as getCreateFacilityMemberProfile;
         // this.editData(this.reqId)
        }
      });
  }
  submitRole(){
     
    this.spinner.show();
    const role = this.rolesForm.value.roleControl;
    const payload = {
         facilityMemberProfileID: this.FacilityMemberProfileID,
         facilityMemberRole: role
    };
    this.apiServices
      .updateFacilityMemberProfile(payload)
      .subscribe((response: any) => {
         
        if (response.statusCode == 201) {
            this.showRoles = false;
            this.spinner.hide();
        } else {
          this.showRoles = false;
          this.errorMessage = 'Role not Updated';
          this.errorMessageArabic = '';
          this.emiratesIdPopUp = true;
          this.spinner.hide();
        }
      });
  }
  

  registerButton() {
    var url = `https://bpmweb.doh.gov.ae/usermanagement/Login.aspx?Home=1`;
    return this.document.location.href = url;
  }

  authenticateReset() {
    localStorage.clear();
    sessionStorage.clear();
    this.authMsalService.logoutRedirect({ postLogoutRedirectUri: '/' });
    this.authenticateErrorModal = false;
  }

  emiratesIDCheck(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onPHPLogin(payload:any) {
    this.spinner.show();

  this.authService.phpLogin(payload).subscribe((response: any) => {
    localStorage.setItem('php', "true");
    // this.signalR.startConnection()
    if (response?.message?.toLowerCase() == "internal") {
    localStorage.removeItem('provisioned')

      this.handleDohUserLogin(response)
    } else {

      this.handleUAEPassLogin(response)
    }
  });
      
  }

  onLogin(role: any, accessToken: any) {
    let payload = {};
    if (role == 'doh') {
      if (this.dohLoginForm.valid) {
        payload = {
          application_user: this.dohLoginForm.get('dohEmail')?.value,
          application_password: accessToken,
        };
        this.authService.nonHCF(payload).subscribe((response: any) => {
          this.handleDohUserLogin(response);
        });
      }
    } else if (role == 'uaepass') {
      this.emiratesIdPopUp = !this.emiratesIdPopUp;
    }
  }

  handleDohUserLogin(response:any) {
    if (response.statusCode == 200 && response.result) {
      localStorage.setItem('isMsal', 'true');

      localStorage.setItem('userId', response.result.systemUserId);
      localStorage.setItem('fullname', response.result.fullname);
      // localStorage.setItem('email', response.result.email);
      // localStorage.setItem('designation', response.result.designation);
      localStorage.setItem('csrf_token', response.result.csrfToken);

      localStorage.setItem(
        'role',
        JSON.stringify(response.result.systemUserRole)
      );
      this.authService.isAuthenticated();
      this.authService.sendDataToUserRoleObservable(response.result.systemUserRole);
 
      this.getAllIdnDiseaseByUserId(response.result.systemUserId);
      this.getAllNationalityByUserId(response.result.systemUserId);
      
      if (this.role.CDDBasicUser() || this.role.CDDUser() || this.role.superCDDRole()) {
        this.route.navigate(['/dashboard']);
      }
      else if (this.role.amrSuperRole() || this.role.amrBasicRole()) {
        this.route.navigate(['/dashboard/amr-dashboard']);
      } 
      this.signalR.startConnection()

      this.spinner.hide()
    } else {
      this.spinner.hide();
      this.authenticateErrorModal = true;
      this.MSALError = 'User Not Found or User Disabled'
    }
  }

  loginToDashboard(emiratesId: string, UAEPassToken: any) {
     
    this.spinner.show();
    let payload = {
      emiratesId: emiratesId,
      token: UAEPassToken
    }
    this.authService.login(payload).subscribe((response: any) => {
       this.handleUAEPassLogin(response)

    });
  }

  handleUAEPassLogin(response:any) {
    if (response.statusCode == 200 && response.result) {
         
      localStorage.setItem('userId', response.result.result.userId);
      localStorage.setItem('csrf_token', response.result.result.csrfToken);
      // this.signalR.startConnection()

      const HFCrole = response.result.result.roles;
      let role = localStorage.setItem('role', JSON.stringify(HFCrole));
      localStorage.setItem('fullname', response.result.result.facilityMemberProfileDetails[0].fullname);
      localStorage.setItem('healthCareFacilityId', response.result.result.facilities[0].id);
      localStorage.setItem('healthCareFacilityName', response.result.result.facilities[0].name);
      this.authService.isAuthenticated();
      this.authService.sendDataToUserRoleObservable(role);
      const getRole = localStorage.getItem('role');
      if (getRole) {
        this.userRole = getRole;
      }
      if (this.role.idnFacility()) {
        this.route.navigate(['/dashboard/idn-notifications']);
      } else {
        this.route.navigate(['/dashboard/amr-files']);
        
      }
      this.spinner.hide();
    } else if (response.statusCode == 401 && response.message == "Role not found"){
      
        this.FacilityMemberProfileID = response.result.result.facilityMemberProfileID;
        localStorage.setItem('token', response.result.result.token);
        localStorage.setItem('userId', response.result.result.userId);

        this.authService.isAuthenticated();

        this.getOptionsFacilityMemberProfile();
        this.showRoles = true;
        // this.recallLogin = true;
        // this.checkRole( emiratesId,UAEPassToken, response.result.facilityMemberProfileID);
        
    }
     else if (response.statusCode == 401 && response.message == "Your Request is Pending for Approval"){
      this.FacilityMemberProfileID = response.result.result.facilityMemberProfileID;
      localStorage.setItem('token', response.result.result.token);
      localStorage.setItem('userId', response.result.result.userId);

      this.authService.isAuthenticated();

      this.getOptionsFacilityMemberProfile();
        this.showRoles = true;

      // this.recallLogin = false;
      // this.checkRole( emiratesId,UAEPassToken, response.result.facilityMemberProfileID);
      
      // this.emiratesIdPopUp = true;
      // this.errorMessage = response.message;
      // this.spinner.hide();
    }
     else if (response.statusCode == 401 ){
      this.emiratesIdPopUp = true;
      this.errorMessage = response.message;
      this.spinner.hide();
    }
    else {
      this.spinner.hide();
      this.emiratesIdPopUp = true;
      this.errorMessage = 'Something went wrong please try again later';
    }
  }
  closeLoginPopup() {
    this.emiratesIdPopUp = false;
    this.dohLogPopUp = false;
    this.dohLoginForm.reset();
    this.nonDohLoginForm.reset();
    this.spinner.hide();
    this.route.navigate(['/login']);
  }
  /* ends here */

  exitErrorlogin() {
    this.errorLogin = false;
  }

  loginRedirect() {
    this.authMsalService.loginRedirect();
  }

  setLoginDisplay(token: any) {
    console.log(token)
    this.spinner.show();
    var authData = this.authMsalService.instance.getAllAccounts();
    this.loginDisplay = authData.length > 0;
    const useremail = authData[0].username;
    const accessToken = token?.accessToken
    if (useremail) {
      this.dohLoginForm.get('dohEmail')?.setValue(useremail);
      this.onLogin('doh', accessToken);
    }
  }


  async getUserInfoFromIntegration(accessCode: string) {
    this.spinner.show();
    let request = {
      AccessCode: accessCode,
      rredirectURI: this.uaePassConfig.redirect_url
    };
    localStorage.setItem('provisioned', "1")

    await this.http.post(`${this.integrationURL}/api/Auth/UAEPassCallback`, request).subscribe(async (res: any) => {
      if (res && res.statusCode == 200) {
        var userInformation = res.result as UAEPassResponse;
        this.UAEEID = userInformation.idn;
        this.UAEPassToken = userInformation.token;
        this.loginToDashboard(this.UAEEID, this.UAEPassToken);
      }
      else {
        this.errorMessage = "Failed to generate Access token.";
        this.spinner.hide();
      }
    });
  }

  getAllNationalityByUserId(cddUserId: any) {
    this.apiServices
      .getAllNationalityByUserId(cddUserId)
      .subscribe((response: any) => {
        if (response.statusCode == 200 && response.result) {
          this.cddNationalityList = [];
          this.cddNationalityList = response.result;
          localStorage.setItem('userNationalities', JSON.stringify(response.result));
        } else if (response.statusCode == 404) {
          this.cddNationalityList = [];
        } else {
          this.cddNationalityList = [];
        }
      });
  }

  getAllIdnDiseaseByUserId(cddUserId: any) {
    this.apiServices
      .getAllDiseaseByUserId(cddUserId)
      .subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.cddIdnDiseaseList = response.result;
          localStorage.setItem('userDisease', JSON.stringify(response.result));
        } else {
          this.cddIdnDiseaseList = [];
        }
      });
  }
}
